import { Button, Callout, Field, Input } from "@nodus/ui";
import { createFileRoute } from "@tanstack/react-router";
import * as React from "react";
import { AuthCard } from "../../../app/auth-card";
import { useCaptcha } from "../../../app/turnstile";
import { useAuth } from "../../../auth/auth-context";

export const Route = createFileRoute("/forgot-password")({ component: ForgotPassword });

function ForgotPassword() {
  const { auth } = useAuth();
  const captcha = useCaptcha();
  const [email, setEmail] = React.useState("");
  const [sent, setSent] = React.useState(false);
  const [busy, setBusy] = React.useState(false);
  const [error, setError] = React.useState<string>();

  // Supabase answers the same for known and unknown addresses, so an error here is a captcha, rate-limit or
  // network failure the user can act on, never a hint about which accounts exist.
  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(undefined);
    try {
      await auth.sendPasswordReset(email.trim(), `${window.location.origin}/auth/callback?next=/reset-password`, captcha.token);
      setSent(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Could not send the reset link.");
    } finally {
      setBusy(false);
      captcha.reset();
    }
  }

  return (
    <AuthCard title="Reset your password">
      {sent ? (
        <Callout tone="success" role="status" title="Check your email">
          If an account exists for {email}, a reset link is on its way.
        </Callout>
      ) : (
        <form className="grid gap-4" onSubmit={submit}>
          <Field id="email" label="Email" required>
            <Input type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} />
          </Field>
          {captcha.widget}
          {error ? <p role="alert" className="text-ui text-danger-fg">{error}</p> : null}
          <Button type="submit" disabled={busy || !email || !captcha.ready}>Send reset link</Button>
        </form>
      )}
    </AuthCard>
  );
}
